import React, { useCallback, useEffect } from 'react';
import { DepositResult, DepositTypes, StatusReasonEnum } from 'store/payment/interfaces';
import { parsePspReturnQuery } from 'utils/parsePspReturnQuery';
import { pspReturnVerdict } from 'utils/pspReturnVerdict';
import { Pages } from 'interfaces/main';
import { useHistory } from 'react-router-dom';

const successPages = new Map([
    ['planPurchase', `/${Pages.PROP}/${Pages.PROP__NEW_CHALLENGES}/${Pages.PROP__NEW_CHALLENGES__DEPOSIT_SUCCESS}`],
    ['keeperPurchase', `/${Pages.PROP}/${Pages.PROP__NEW_CHALLENGES}/${Pages.PROP__KEEPER__PURCHASE}`],
]);

const successRoute = () => {
    if (localStorage?.getItem('keeperPurchase')) {
        localStorage.removeItem('keeperPurchase');
        return successPages.get('keeperPurchase');
    } else {
        return successPages.get('planPurchase');
    }
};
export const useSetDepositResults = ({
    depositType,
    payment_resetState,
    payment_setDepositType,
    payment_setDepositResult,
    // depositSuccessRedirectUrl,
}) => {
    const history = useHistory();
    useEffect(() => {
        window.addEventListener('message', checkIframeEvent, false);
        window.addEventListener('storage', checkIframeEvent, false);
        return () => {
            window.removeEventListener('message', checkIframeEvent);
            window.removeEventListener('storage', checkIframeEvent);
        };
        //eslint-disable-next-line
    }, [depositType]);

    const checkIframeEvent = useCallback(
        (event) => {
            const paymentType = { ...depositType };

            let eventData = event.data;
            if (event.type === 'storage') {
                if (event?.storageArea?.message) {
                    eventData = JSON.parse(event.storageArea.message);
                }
                if (event?.newValue) {
                    try {
                        eventData = JSON.parse(event?.newValue ?? {});
                    } catch (e) {}
                }
            }

            if (event.type === 'manual') {
                eventData = { queryString: event.data };
            }

            let { queryString, paymentCanceled } = eventData ?? {};
            if (paymentCanceled) {
                payment_resetState();
                return payment_setDepositType(paymentType);
            }

            if (paymentType?.type === DepositTypes.bridgerpay) {
                if (event.data.event === '[bp]:redirect') {
                    const bridgerUrl = new URL(event.data.url);
                    queryString = bridgerUrl.search;
                }
            }

            if (!queryString) return;
            try {
                const parsedQueryString = parsePspReturnQuery(queryString) as any;
                let depositResultObj: DepositResult | undefined;
                paymentType.type = paymentType.type ?? parsedQueryString.psp ?? DepositTypes.unknown;

                switch (paymentType.type) {
                    case DepositTypes.payotop:
                    case DepositTypes.coriunderDynamic: {
                        if (parsedQueryString?.replyCode === '600') {
                            payment_resetState();
                            return payment_setDepositType(depositType);
                        }
                        depositResultObj = {
                            amount: parsedQueryString.trans_amount,
                            currency: parsedQueryString.trans_currency,
                            status: pspReturnVerdict(parsedQueryString.replyCode, '000'),
                            transactionId: parsedQueryString.trans_id,
                        };
                        break;
                    }
                    case DepositTypes.safecharge:
                        depositResultObj = {
                            amount: parsedQueryString.totalAmount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.ppp_status, 'OK'),
                            transactionId: parsedQueryString.TransactionID,
                        };
                        break;
                    case DepositTypes.praxis:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'approved'),
                            transactionId: parsedQueryString.order_id,
                        };
                        break;
                    case DepositTypes.bridgerpay:
                        depositResultObj = {
                            amount: 0,
                            currency: 'unknown',
                            status: pspReturnVerdict(parsedQueryString.status, 'approved'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payretailers:
                        depositResultObj = {
                            amount: 0,
                            currency: 'unknown',
                            status: pspReturnVerdict(parsedQueryString.status, 'approved'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.neobanq:
                        depositResultObj = {
                            amount: 0,
                            currency: 'unknown',
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.order_id,
                        };
                        break;
                    case DepositTypes.bpwallet:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'approved'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.gr8pay: {
                        if (parsedQueryString?.replyCode === '600') {
                            payment_resetState();
                            return payment_setDepositType(paymentType);
                        }
                        depositResultObj = {
                            amount: parsedQueryString.trans_amount,
                            currency: parsedQueryString.trans_currency,
                            status: pspReturnVerdict(parsedQueryString.replyCode, '000'),
                            transactionId: parsedQueryString.trans_id,
                        };
                        break;
                    }
                    case DepositTypes.maldopay:
                        depositResultObj = {
                            amount: 0,
                            currency: 'unknown',
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.pagsmile:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: false,
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.paymentechnologies:
                        depositResultObj = {
                            amount: 0,
                            currency: 'unknown',
                            status: pspReturnVerdict(parsedQueryString.status, 'approved'),
                            transactionId: '',
                        };
                        break;
                    case DepositTypes.ngpayment:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.knoxsecure:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.quikipay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.rafinita:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.sinterio:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.stripe: {
                        // Backing out of Stripe's hosted page returns to cancel_url with
                        // status=canceled. That is an abandoned checkout, not a failed payment - the
                        // order is still Pending - so go back to the deposit form the way the
                        // payotop/gr8pay guards above do, instead of stamping FAILED_PSP.
                        if (parsedQueryString?.status === 'canceled') {
                            payment_resetState();
                            return payment_setDepositType(depositType);
                        }
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    }
                    case DepositTypes.cipherbc:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.gcg:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.neonpay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.dikeshield:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.nonstopay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.korapay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.kasha:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.pelecard:
                        if (parsedQueryString?.PelecardStatusCode === '555') {
                            payment_resetState();
                            return payment_setDepositType(paymentType);
                        }
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payport:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.bitolo:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.rixsus:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payrock:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payneteasy:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.vepara:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.nowpayments:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.match2pay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.paytechno:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.StatusCode, '1'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.paragon: {
                        // status is case-insensitive here (as before); status-code 20000 is also approved
                        const byStatus = pspReturnVerdict(parsedQueryString.status?.toLowerCase?.(), 'approved');
                        const byCode = pspReturnVerdict(parsedQueryString['status-code'], '20000');
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: 'unknown',
                            status: byStatus || byCode ? true : byStatus === null && byCode === null ? null : false,
                            transactionId: parsedQueryString.client_orderid,
                        };
                        break;
                    }
                    case DepositTypes.epsilon:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.responseCode, '1'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payku:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.toptechpay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'approved'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.cricpayz:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: true,
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payok:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: true,
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.epay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.paymid:
                        depositResultObj = {
                            amount: 0,
                            currency: 'unknown',
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: 'unknown',
                        };
                        break;
                    case DepositTypes.instaxchange:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.paytiko:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.digitalcryptopay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: pspReturnVerdict(parsedQueryString.status, 'success'),
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.payzentric:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: true,
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.key2pay:
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: true,
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    case DepositTypes.unknown: {
                        depositResultObj = {
                            amount: parsedQueryString.amount,
                            currency: parsedQueryString.currency,
                            status: true,
                            transactionId: parsedQueryString.orderId,
                        };
                        break;
                    }
                }
                if (!depositResultObj) return;
                // RND-10937: a pending/missing PSP verdict is never a failure. Show it as the normal
                // "processing your purchase" (WAITING) state until the challenge update arrives - the
                // NEW_WAITING copy served from S3 is placeholder text.
                if (depositResultObj.status === null) depositResultObj.status = true;
                // only a confirmed failure is FAILED_PSP
                depositResultObj.statusReason =
                    depositResultObj.status === false ? StatusReasonEnum.FAILED_PSP : undefined;
                payment_resetState();
                payment_setDepositResult(depositResultObj);
                const successRouter = successRoute() ?? '';
                history.replace(successRouter);
            } catch (error) {
                console.log(error);
            }
        },
        [depositType, history, payment_resetState, payment_setDepositResult, payment_setDepositType]
    );

    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('rd') === 'cz') {
            console.log('checkIframeEvent');

            checkIframeEvent({ data: window.location.search, type: 'manual' });
        }
    }, [payment_setDepositType, checkIframeEvent]);
};
